import { Stack, type StackProps } from '@mui/material';

export const ContentBox = ({
  children,
  bordered,
  ...props
}: StackProps & { p?: number; bordered?: true }) => {
  const { p: padding, sx, ...otherProps } = props;

  return (
    <Stack
      sx={[
        ({ palette, shape }) => ({
          backgroundColor: palette.background.paper,
          borderRadius: `${shape.borderRadius}px`,
          border: bordered ? `1px solid ${palette.neutral[200]}` : 'none',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      p={padding ?? 3}
      {...otherProps}
    >
      {children}
    </Stack>
  );
};
